import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Row, Tooltip, Spin } from 'antd';

import CardHeader from '~/components/CardHeader';
import ModalCreate from './Create';
import ModalUpdate from './Update';

import history from '~/services/history';

import { projectIndexFirstRequest, projectIndexRequest, projectReadRequest } from '~/store/modules/project/actions';

import { PlusOutlined, UsergroupAddOutlined, PullRequestOutlined, EditOutlined, HistoryOutlined, ProjectOutlined } from '@ant-design/icons';
import { Container, Empty, FilterContainer, FilterInput, FilterButton, ProjectItem, ProjectItemContainer, ProjectItemTitleContainer, ProjectItemTitle, ProjectItemDetailsContainer, ProjectItemIconsContainer } from './styles';

export default function Project() {
  const dispatch = useDispatch();

  const dataSource = useSelector(store => store.project.list);
  const loading = useSelector(store => store.project.loading);

  const [projectId, setProjectId] = useState();
  const [isVisibleCreate, setIsVisibleCreate] = useState(false);
  const [isVisibleUpdate, setIsVisibleUpdate] = useState(false);
  const [filterSearch, setFilterSearch] = useState('');

  function onFilter(value) {
    setFilterSearch(value);
    dispatch(projectIndexRequest([{ filterSearch: value }]));
  }

  function onProjectUpdate(id) {
    setProjectId(id);
    dispatch(projectReadRequest(id));
    setIsVisibleUpdate(true);
  }

  useEffect(() => {
    dispatch(projectIndexFirstRequest());
  }, []);

  return (
    <Container>
      <CardHeader>
        <FilterContainer>
          <Tooltip title="Pesquisar um projeto">
            <FilterInput placeholder='Digite um termo para busca' value={filterSearch} onChange={e => onFilter(e.target.value)} />
          </Tooltip>
        </FilterContainer>

        <Tooltip title="Criar um novo projeto">
          <FilterButton onClick={() => { setIsVisibleCreate(true); setFilterSearch(''); onFilter(''); }} disabled={loading}>
            <PlusOutlined />
            Novo projeto
          </FilterButton>
        </Tooltip>
      </CardHeader>

      {(loading && !isVisibleUpdate) ? (
        <Container style={{ marginTop: '5%', justifyContent: 'center' }}>
          <Spin />
        </Container>
      ) : (
        <>
          {!dataSource || dataSource.length <= 0 ? (
            <Empty>
              <h2 style={{ textAlign: 'center', width: '100%' }}>Nenhum projeto encontrado.</h2>
            </Empty>
          ) : (
            <Row gutter={24}>
              {dataSource.map(item => {
                var i = 0;

                var words = item.name.split(' ');
                if (words.length <= 1) words = item.name.split('_');
                if (words.length <= 1) words = item.name.split('/');
                if (words.length <= 1) words = item.name.split('|');
                if (words.length <= 1) words = item.name.split('-');

                const initials = words.map(w => {
                  if (i >= 2) return '';
                  if (w.trim().length <= 0) return '';

                  const letter = w.trim().substring(0, 1);

                  if (!letter.match(/[a-z]/i)) return '';

                  i++;

                  return letter.toUpperCase();
                });

                const avatarColor = item.color;

                return (
                  <ProjectItem xs={24} lg={12} xl={8}>
                    <ProjectItemContainer>
                      <ProjectItemTitleContainer onClick={() => onProjectUpdate(item.id)}>
                        <Avatar style={{ backgroundColor: avatarColor, verticalAlign: 'middle' }} size="large">
                          {initials}
                        </Avatar>

                        <ProjectItemTitle>{item.name}</ProjectItemTitle>

                        <EditOutlined />
                      </ProjectItemTitleContainer>

                      <ProjectItemIconsContainer>
                        <Tooltip title="Dashboard">
                          <ProjectOutlined className='icon-project' onClick={() => history.push(`/projects/${item.id}/dashboard`)} />
                        </Tooltip>

                        <Tooltip title="Linha do tempo">
                          <HistoryOutlined className='icon-sprint' onClick={() => history.push(`/projects/${item.id}/sprints/current`)} />
                        </Tooltip>

                        <Tooltip title="Time/Equipe">
                          <UsergroupAddOutlined className='icon-feature' onClick={() => history.push(`/projects/${item.id}/teams`)} />
                        </Tooltip>

                        <Tooltip title="Repositório">
                          <PullRequestOutlined className='icon-repository' onClick={() => history.push(`/projects/${item.id}/repositories`)} />
                        </Tooltip>

                      </ProjectItemIconsContainer>
                    </ProjectItemContainer>
                  </ProjectItem>
                );
              })}
            </Row>
          )}
        </>
      )}

      <ModalCreate isVisible={isVisibleCreate} setIsVisible={setIsVisibleCreate} />
      <ModalUpdate isVisible={isVisibleUpdate} setIsVisible={setIsVisibleUpdate} id={projectId} />
    </Container>
  );
}
